import { render, staticRenderFns } from "./HomeDeals.vue?vue&type=template&id=15452c7d&scoped=true"
import script from "./HomeDeals.vue?vue&type=script&lang=js"
export * from "./HomeDeals.vue?vue&type=script&lang=js"
import style0 from "./HomeDeals.vue?vue&type=style&index=0&id=15452c7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15452c7d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DealCard: require('/app/components/DealCard.vue').default})
